import Backbone from "backbone";
import {pathname} from "../../common/others/Configuration";
import $ from "jquery";
import SharedDispatcher from "../../common/others/SharedDispatcher";

// https://www.getpostman.com/collections/48db3d6ea6444c37a029

export default Backbone.View.extend({
    selectors: {
      checkboxesPrefs: ".js-prefs",
      groupPrefs: ".js-prefs-group",
      iconsPrefs: ".js-prefs-iconState",
      refuseFrequencyButton: ".js-button-refuseFrequency",
      groupPopin: ".js-group-popin",
      smsPopin: ".js-sms-popin",
      smsInput: ".js-input-sms",
      smsSubmit: ".js-button-addPhone",
      smsToggle: ".js-toggle-smsNumber",
      smsNumber: ".js-smsNumber"
    },

    events: {
      "change .js-checkbox-group": "onPrefsGroupChanged",
      "change .js-checkbox-sms": "onPrefsSmsChanged",
      "change .js-checkbox-partners": "onPrefsPartnersChanged",
      "change .js-checkbox-share": "onPrefsShareChanged",
      "click .js-button-refuseFrequency": "onPrefsFrequencyRefuse",
      "click .js-button-cancelPopin": "onPrefsFrequencyAccept",
      "blur .js-input-sms": "onInputSmsBlur",
      "keyup .js-input-sms": "allowSmsSubmit",
      "click .js-toggle-smsPopin": "toggleSmsPopin",
      "click .js-button-addPhone": "addSmsNumber",
    },

    // SMS alerts
    onPrefsSmsChanged: function (e) {
      var targetElement = $(e.currentTarget);
      var apiType = "POST";
      // TODO move to account configuration
      var apiUrl = "/account/api/v1/news-letter/add";
      var apiKey = "Sms";

      // No phone number, so open the popin to add it
      if ($(this.selectors.smsToggle).hasClass("hide")) {
        targetElement.prop("checked", !targetElement.prop("checked"));
        this.toggleSmsPopin();
      }
      // Call the API to enable/disable SMS alerts
      else {
        this.modifyPrefs(targetElement, apiType, apiUrl, apiKey);
      }
    },

    // Disable/enable the SMS popin button who call the phone number addition/modification
    allowSmsSubmit: function () {
      $(this.selectors.smsInput).valid();

      if ($(this.selectors.smsInput).hasClass("valid")) {
        $(this.selectors.smsSubmit).prop("disabled", false);
      }
      else {
        $(this.selectors.smsSubmit).prop("disabled", true);
      }
    },

    // Call the API to set/modify the phone number for SMS alerts
    addSmsNumber: function () {
      var targetElement = $(".js-checkbox-sms");
      var apiType = "POST";
      // TODO move to account configuration
      var apiUrl = "/account/api/v1/news-letter/cellphone";
      var apiKey = $(this.selectors.smsInput).val();

      var postData = {
        CellPhone: apiKey
      };

      $.ajax({
        type: apiType,
        url: pathname + apiUrl,
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify(postData),
        success: () => {
          // Hide popin
          this.toggleSmsPopin();

          // Call the API to enable SMS alerts if no phone number
          if ($(this.selectors.smsToggle).hasClass("hide")) {
            $(this.selectors.smsToggle).removeClass("hide");
            targetElement.prop("checked", true).trigger("change");
          }

          // Display the phone number
          $(this.selectors.smsNumber).text(apiKey);

        },
        error: function () {
          this.allowSmsSubmit();
          SharedDispatcher.trigger("flashmessage:show");
        }
      });
    },

    // Toggle display of SMS popin
    toggleSmsPopin: function () {
      $(this.selectors.smsPopin).toggleClass("hide");
    },

    // Fix the label position when phone number is filled
    onInputSmsBlur: function (e) {
      var targetElement = $(e.currentTarget);
      var valElement = targetElement.val();

      if (valElement.length) {
        targetElement.addClass('filled');
      } else {
        targetElement.removeClass('filled');
      }
    },

    // Fnac Darty alerts
    onPrefsGroupChanged: function (e) {
      var targetElement = $(e.currentTarget);
      var apiType = "POST";
      // TODO move to account configuration
      var apiUrl = "/account/api/v1/news-letter/add";
      var apiKey = "Fnac";

      // Call the API to enable Fnac Darty alerts
      if (targetElement.prop("checked")) {
        this.modifyPrefs(targetElement, apiType, apiUrl, apiKey);
      }
      // Display frequency popin when disable alert
      else {
        $(this.selectors.groupPopin).removeClass("hide");
      }
    },

    // Refuse alerts frequency option for Fnac Darty alerts
    onPrefsFrequencyRefuse: function () {
      var targetElement = $(".js-checkbox-group");
      var apiType = "POST";
      // TODO move to account configuration
      var apiUrl = "/account/api/v1/news-letter/add";
      var apiKey = "Fnac";

      this.modifyPrefs(targetElement, apiType, apiUrl, apiKey);

      $(this.selectors.groupPopin).addClass("hide");
    },

    // Reduce alerts frequency option for Fnac Darty alerts
    onPrefsFrequencyAccept: function () {
      var targetElement = $(".js-checkbox-group");
      targetElement.prop("checked", !targetElement.prop("checked"));
      $(this.selectors.groupPopin).addClass("hide");
    },

    // Partners alerts
    onPrefsPartnersChanged: function (e) {
      var targetElement = $(e.currentTarget);
      var apiType = "POST";
      // TODO move to account configuration
      var apiUrl = "/account/api/v1/news-letter/add";
      var apiKey = "FnacPartners";

      this.modifyPrefs(targetElement, apiType, apiUrl, apiKey);
    },

    // Data sharing
    onPrefsShareChanged: function(e) {
      var targetElement = $(e.currentTarget);
      var apiType = "POST";
      // TODO move to account configuration
      var apiUrl = "/account/api/v1/news-letter/add";
      var apiKey = "ShareInfo";

      this.modifyPrefs(targetElement, apiType, apiUrl, apiKey);
    },

    // Update preferences
    modifyPrefs: function (targetElement, apiType, apiUrl, apiKey) {
      var postData = [{
        key: apiKey,
        IsEnabled: targetElement.prop("checked")
      }];

      $.ajax({
        type: apiType,
        url: pathname + apiUrl,
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify(postData),
        success: () => {
          targetElement.parents(this.selectors.checkboxesPrefs).find(this.selectors.iconsPrefs).toggleClass("hide");
        },
        error: () => {
          targetElement.prop("checked", !targetElement.prop("checked"));
          SharedDispatcher.trigger("flashmessage:show");
        }
      });
    }

  });
